import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react';

const SimpleModal = ({
	title,
	trigger,
	render,
	open,
	scrolling,
	actions,
	...props
}) => {
	const [isOpen, setOpen] = useState(open);
	useEffect(() => setOpen(open), [open]);

	return (
		<Modal
			trigger={trigger(() => setOpen(true))}
			open={isOpen}
			closeOnDimmerClick={false}
			onClose={() => setOpen(false)}
			closeIcon
			scrolling={scrolling || null}
			{...props}
		>
			<Modal.Header>{title}</Modal.Header>
			<Modal.Content>{render(setOpen)}</Modal.Content>
			{actions ? (
				<Modal.Actions
					actions={actions}
					onActionClick={(e, data) => data && data.close && setOpen(false)}
				/>
			) : null}
		</Modal>
	);
};

SimpleModal.defaultProps = {
	open: false
};

SimpleModal.propTypes = {
	title: PropTypes.string.isRequired,
	trigger: PropTypes.func.isRequired,
	render: PropTypes.func.isRequired,
	open: PropTypes.bool
};

export default SimpleModal;
